import Vue from 'vue';
import VCalendar from 'v-calendar';

Vue.use(VCalendar);



// WEBPACK FOOTER //
// ./src/plugins/v-calendar.js